<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <search-form
      ref="searchForm"
      :fields="search"
    />

    <el-table
      :data="datas"
      resource="admin-users"
    >
      <!-- <el-table-column
        prop="id"
        label="ID"
        align="center"
        show-overflow-tooltip
        min-width="2%"
      />-->
      <el-table-column
        prop="area_name"
        label="发送区域"
        align="center"
        show-overflow-tooltip
        min-width="8%"
      >
        <template #default="{ row }">
          <el-tag class="mr-1">
            {{ row.area_name }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="is_deposit"
        label="是否缴纳押金"
        align="center"
        show-overflow-tooltip
        min-width="5%"
      >
        <template #default="{ row }">
          <el-tag
            class="mr-1"
            type="success"
            v-if="row.is_deposit==1"
          >
            已缴纳
          </el-tag>
          <el-tag
            class="mr-1"
            type="danger"
            v-if="row.is_deposit==0"
          >
            未缴纳
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="is_card_certified"
        label="是否实名"
        align="center"
        show-overflow-tooltip
        min-width="5%"
      >
        <template #default="{ row }">
          <el-tag
            class="mr-1"
            type="success"
            v-if="row.is_card_certified==1"
          >
            已实名
          </el-tag>
          <el-tag
            class="mr-1"
            type="danger"
            v-if="row.is_card_certified==0"
          >
            未实名
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column
        prop="is_search"
        label="是否高级筛选"
        align="center"
        show-overflow-tooltip
        min-width="5%"
      >
        <template #default="{ row }">
          <el-tag
            class="mr-1"
            type="success"
            @click="Users(row.arr_ids)"
            v-if="row.is_search==1"
          >
            是
          </el-tag>
          <el-tag
            class="mr-1"
            type="danger"
            v-if="row.is_search==0"
          >
            否
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="template_id"
        label="短信模板"
        align="center"
        show-overflow-tooltip
        min-width="6%"
      />

      <el-table-column
        prop="created_at"
        label="添加时间"
        align="center"
        show-overflow-tooltip
        min-width="5%"
      />
      <el-table-column
        prop="updated_at"
        label="修改时间"
        align="center"
        show-overflow-tooltip
        min-width="5%"
      />
      <!-- <el-table-column
        label="操作"
        align="center"
        show-overflow-tooltip
        width="150"
      >
        <template #default="{ row, $index }">
          <el-button-group>
            <row-to-edit/>
            <row-destroy/>
          </el-button-group>
        </template>
      </el-table-column> -->
    </el-table>
    <div class="card-footer">
      <pagination :page="page" />
    </div>

    <el-dialog
      title="已发用户"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <el-table
        :data="users"
        :border="false"
      >
        <el-table-column
          prop="id"
          label="ID"
          show-overflow-tooltip
          align="center"
          width="55"
        />

        <el-table-column
          prop="mobile"
          label="手机"
          width="180"
          align="right"
        />
      </el-table>
      <div class="card-footer">
        <pagination
          :page="pagess"
          @current-change="walletcurrentpage"
          @size-change="walletpagesize"
          :auto-push="false"
        />
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="dialogVisible = false"
        >确 定</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import SearchForm from "@c/SearchForm";
import Pagination from "@c/Pagination";
import { getUsers, getGroupSendSmsList } from "@/api/users";
import { getAreas } from "@/api/area";
import { mixinsAutoPageSize } from "@/libs/utils";
import { getAdminUsersMerchant } from "@/api/admin-merchant";
import env from "../../../env";
export default {
  name: "Index",
  components: {
    SearchForm,
    Pagination
  },
  data() {
    return {
      search: [
        {
          type: "el-select",
          field: "area_id",
          label: "发送区域",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        },
        {
          field: "template_id",
          label: "模板ID"
        }
      ],
      datas: [],
      page: null,
      first_blood: true,
      dialogVisible: false,
      users: [],
      pagess: null,
      ids: []
    };
  },
  mixins: [mixinsAutoPageSize],
  async created() {
    const [{ data: areas }] = await Promise.all([getAreas({ all: 1 })]);
    this.search[0].options.push.apply(this.search[0].options, areas);
    if (this.$store.state.users.user.roles[0] === "administrator") {
      const [{ data: merchant }] = await Promise.all([
        getAdminUsersMerchant({ all: 1 })
      ]);

      if (env.isPosSwitch == true) {
        this.search.push({
          type: "el-select",
          field: "merchant_id",
          label: "商户",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        });
        this.search[2].options.push.apply(
          this.search[2].options,
          merchant.data
        );
      }
    }
  },
  watch: {
    $route: {
      async handler(newVal) {
        await this.autoPageSize(53, newVal);
        const {
          data: { data, meta }
        } = await getGroupSendSmsList(newVal.query);
        this.datas = data;
        this.page = meta;
      },
      immediate: true
    }
  },
  methods: {
    async Users(ids) {
      let _this = this;
      _this.dialogVisible = true;

      this.ids = ids;
      const {
        data: { data, meta }
      } = await getUsers({ ids: _this.ids });
      this.users = data;
      this.pagess = meta;
    },

    async walletcurrentpage(i) {
      let _this = this;

      this.pagess.current_page = i;
      const {
        data: { data, meta }
      } = await getUsers({ ids: _this.ids });
      this.users = data;
      this.pagess = meta;
    },
    async walletpagesize(i) {
      let _this = this;

      this.pagess.page_size = i;
      const {
        data: { data, meta }
      } = await getUsers({ ids: _this.ids });
      this.users = data;
      this.pagess = meta;
    }
  }
};
</script>
